import { template as template_85fa4f43484749e1911715c58f186e05 } from "@ember/template-compiler";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import colors from "glesys-controlpanel/helpers/colors";
import { t } from "ember-intl";
export default template_85fa4f43484749e1911715c58f186e05(`
  <span
    class="text-2xs px-1 leading-none py-1 font-bold uppercase tracking-wide rounded-sm {{colors 'pink'}}"
    {{mergeClasses}}
    ...attributes
  >
    {{#if @text}}
      {{@text}}
    {{else}}
      {{t "label.beta"}}
    {{/if}}
  </span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
